let requestCount = 0;

export const loadingHandler = {
    startLoading: () => {
        requestCount++;
    },
    stopLoading: () => {
        requestCount--;
        return requestCount === 0;
    },
    reset: () => {
        requestCount = 0;
    },
};
